import { Component } from 'san';
import * as echarts from 'echarts';
import * as _ from 'lodash';

export default class DashboardPie extends Component {
    myChart: echarts.ECharts;
    constructor(options: any) {
        super(options);
    }

    // initData(): {} {
    //     return {};
    // }

    inited() {}

    attached() {
        this.initChart();

        // 监听，若widget大小发生变化，chart resize
        const elem = document.getElementById(`chart-${this.data.get('type')}`);
        const resizeObserver = new ResizeObserver(() => {
            this.myChart.resize();
        });
        resizeObserver.observe(elem);
    }

    initChart() {
        const type = this.data.get('type');
        const chartDom = document.getElementById(`chart-${type}`);
        if (chartDom) {
            echarts.dispose(document.getElementById(`chart-${type}`));
        }
        this.myChart = echarts.init(chartDom);
        const option = {
            tooltip: {
                trigger: 'item',
                formatter: (params) => {
                    return [
                        '<div style="margin-bottom: 4px;">'+params.seriesName+'</div>',
                        '<div style="display: inline-block; width: 10px; height:10px; background-color: '+params.color+'; border-radius: 50%; margin-right: 4px;"></div><span style="margin-right: 26px;">'+params.name+'</span><span style="font-weight:700">'+params.value+' ('+params.percent+'%)</span>',
                      ].join('');
                },
            },
            legend: {
                orient: 'vertical',
                top: '16',
                right: '16',
            },
            title: {
                text: type,
                left: '16',
                top: '4',
                textStyle: {
                    color: '#1A1A1A',
                    fontWeight: 'normal',
                    fontSize: '14',
                }
            },
            series: [
                {
                    name: type,
                    type: 'pie',
                    radius: '60%',
                    data: this.getItems(),
                    right: '40%',
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                        },
                    },
                    label: {
                        show: false
                    },
                },
            ],
        };

        option && this.myChart.setOption(option);
    }

    getItems() {
        const oldItems = this.data.get('items');
        const items = [];
        _.forEach(oldItems, (item) => {
            items.push({
                name: item.key,
                value: item.value,
            });
        });
        return items;
    }
}
